import { useState, useEffect } from "react";
import api from "@/lib/api";
import AdminLayout from "@/components/AdminLayout";

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/orders")
      .then((r) => setOrders(r.data))
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <AdminLayout>
      <div data-testid="admin-orders-page">
        <h1 className="text-2xl font-black admin-text mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Orders</h1>
        <p className="text-xs text-slate-500 mb-4">{orders.length} total orders</p>

        {loading ? (
          <div className="text-slate-400 py-8">Loading...</div>
        ) : orders.length === 0 ? (
          <div className="text-sm text-slate-400 py-8">No orders yet.</div>
        ) : (
          <div className="space-y-2" data-testid="orders-list">
            {orders.map((order) => (
              <div key={order.id} className="bg-white p-4">
                <div className="flex items-start justify-between mb-2">
                  <div>
                    <p className="text-sm font-bold text-slate-900">{order.user?.name || "User"}</p>
                    <p className="text-xs text-slate-500">{order.user?.email || ""}</p>
                  </div>
                  <span className={`text-[10px] font-bold uppercase px-2 py-1 ${
                    order.status === "success" ? "bg-green-100 text-green-700" : order.status === "failed" ? "bg-red-100 text-red-700" : "bg-amber-100 text-amber-700"
                  }`}>
                    {order.status}
                  </span>
                </div>
                <p className="text-xs text-slate-600">{order.course?.title || "Course"}</p>
                <div className="flex items-center justify-between mt-2">
                  <span className="text-base font-black text-slate-900">&#8377;{order.amount}</span>
                  <span className="text-[10px] text-slate-400">{order.created_at ? new Date(order.created_at).toLocaleDateString() : ""}</span>
                </div>
                {order.razorpay_order_id && (
                  <p className="text-[10px] text-slate-400 mt-1">Order ID: {order.razorpay_order_id}</p>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
